// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sort-asc::after {\r\n  content: '▲';\r\n  font-size: 0.75rem;\r\n  margin-left: 0.5rem;\n}\n.sort-desc::after {\r\n  content: '▼';\r\n  font-size: 0.75rem;\r\n  margin-left: 0.5rem;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
